<script>
import { mapActions } from "vuex";

export default {
  title: "Criar cupom para o profissional",
  props: {
    dialog: { type: Boolean, required: true }
  },
  data() {
    return {
      loader: false,
      createdItem: { max_usage: { total: 0 } }
    };
  },
  methods: {
    ...mapActions("professionalCoupons", ["createCoupon", "getItems"]),

    async save() {
      this.loader = true;

      try {
        await this.createCoupon(this.createdItem);

        this.$toast.success("Cupom criado com sucesso!");

        await this.getItems();
      } catch (e) {
        this.$toast.error("Não foi possível criar o cupom!");
      }

      this.loader = false;
      this.closeDialog();
    },

    closeDialog() {
      this.$emit("close");
    }
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    }
  }
};
</script>

<template>
  <v-dialog v-model="dialog" max-width="500px" @click:outside="closeDialog">
    <v-card>
      <v-card-title>
        <span class="headline">Cadastrar cupom</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="createdItem.max_usage.total"
                label="Uso máximo"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog">
          Cancelar
        </v-btn>
        <v-btn color="primary" text @click="save" :loading="loader">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Coupons/Create.vue